import type { AuthUser, GrantedPermissionLevel, PermissionLevel } from './types';

const LEVEL_RANK: Record<PermissionLevel, number> = { none: 0, read: 1, edit: 2 };

/**
 * Efektivní úroveň přístupu uživatele k uzlu katalogu. Konfigurační (super-user) uživatel
 * (`isConfig`) má vždy `edit`. Bez přihlášeného uživatele (`null`/`undefined` — např. během
 * načítání) vrací `none`. Jediné místo, kde se kombinuje `isConfig` s mapou oprávnění — sdílí ho
 * {@link userHasPermission}, PermissionGate, filtr menu i field primitiva, aby logika zůstala
 * konzistentní s backendovým bypassem v `AuthorizationBehavior`.
 */
export function getPermissionLevel(
  user: AuthUser | null | undefined,
  permission: string
): PermissionLevel {
  if (!user) return 'none';
  if (user.isConfig) return 'edit';
  return user.permissions.get(permission) ?? 'none';
}

/**
 * Má uživatel na uzlu alespoň danou úroveň? Škála je ordinální (`edit` implikuje `read`),
 * default `read` odpovídá původní sémantice „má oprávnění" (menu, gate agend).
 */
export function userHasPermission(
  user: AuthUser | null | undefined,
  permission: string,
  minLevel: GrantedPermissionLevel = 'read'
): boolean {
  return LEVEL_RANK[getPermissionLevel(user, permission)] >= LEVEL_RANK[minLevel];
}
